module.exports = __webpack_public_path__ + "static/media/RP-64.99085257.pdf";